import React from 'react';
import {IconProps} from './types';
import {getToken} from '@tickchak/react-share/app';

const WarningIcon: React.FC<IconProps> = ({
    width = 20,
    height = 20,
    className,
    fill = getToken('color.state.warning.main')}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 20 20"
            fill="none"
            className={className}
        >
            <circle cx="10" cy="10" r="10" fill={fill} />
            <path
                d="M9.16781 10.4519V5.45187C9.16781 5.23086 9.25561 5.0189 9.41189 4.86262C9.56817 4.70634 9.78013 4.61854 10.0011 4.61854C10.2222 4.61854 10.4341 4.70634 10.5904 4.86262C10.7467 5.0189 10.8345 5.23086 10.8345 5.45187V10.4519C10.8345 10.6729 10.7467 10.8848 10.5904 11.0411C10.4341 11.1974 10.2222 11.2852 10.0011 11.2852C9.78013 11.2852 9.56817 11.1974 9.41189 11.0411C9.25561 10.8848 9.16781 10.6729 9.16781 10.4519Z"
                fill="white"
            />
            <path
                d="M8.75114 13.7852C8.74433 13.6177 8.77174 13.4505 8.83172 13.2939C8.89169 13.1373 8.98297 12.9946 9.09996 12.8745C9.21695 12.7544 9.35721 12.6594 9.51215 12.5953C9.6671 12.5313 9.83349 12.4995 10.0011 12.5019C10.3294 12.5038 10.6442 12.6322 10.8801 12.8603C11.1161 13.0885 11.2549 13.3989 11.2678 13.7269C11.2745 13.8919 11.2478 14.0566 11.1893 14.211C11.1308 14.3655 11.0416 14.5065 10.9272 14.6256C10.8128 14.7447 10.6754 14.8394 10.5234 14.9041C10.3715 14.9687 10.208 15.002 10.0428 15.0019C9.71166 15.0065 9.39168 14.8822 9.1506 14.6551C8.90952 14.428 8.76626 14.116 8.75114 13.7852Z"
                fill="white"
            />
        </svg>
    );
};

export default WarningIcon;
